import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react'
import { Button } from 'primereact/button';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { Fetch } from '../../shared/Fetch';
import { QAInput } from '../../shared/QAInput';
import { QACheckbox } from '../../shared/QACheckbox';

interface IProps {
    singleData: any;
    open: boolean;
    hideDialog: () => void;
    toast: any;
    reload: boolean;
    setReload: (is: boolean) => void;
    hasPermission: (pageName: string, featureName?: string) => Boolean;
};

export interface IFormData {
    id?: number;
    project_Name: string;
    status: boolean
}

export const emptyFormData: IFormData = {
    project_Name: '',
    status: false
}

const schema = yup.object().shape({
    project_Name: yup.string().required("Project Name is required"),
    status: yup.boolean().required("Status is required")
});

export const Form = (props: IProps) => {
    const [loading, setLoading] = useState(false)

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IFormData>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData
    });

    useEffect(() => {
        reset(props.singleData)
    }, [props.singleData])

    const onSubmit = async (data: IFormData) => {
        setLoading(true)
        const method = props.singleData?.id ? "PUT" : "POST";
        const message = props.singleData?.id ? " updated successfully." : "Posted successfully.";
        const response = await Fetch("Projects", method, data, null, props.toast);
        if (response) {
            props.setReload(true);
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
        }
        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset(emptyFormData);
    }

    return (
        <Dialog visible={props.open} style={{ width: '50vw' }} header="Add/Edit Refrence" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
                <div className="flex align-items-center gap-3">
                    <div style={{ flex: 1 }}>
                        <QAInput required name='project_Name' control={control} label='Project Name' error={errors.project_Name?.message} column={9} />
                    </div>
                    <div>
                        <QACheckbox required name='status' control={control} label='Status' error={errors.status?.message} />
                    </div>

                    <div className="flex gap-2">
                        <Button type="submit" loading={loading} style={{ width: '100px', justifyContent: 'center' }} className="mr-2" rounded>
                            Save
                        </Button>
                        <Button type="button" onClick={() => reset()} className="mr-2 btn btn-grey" style={{ width: '100px', justifyContent: 'center' }} severity="secondary" rounded>
                            Cancel
                        </Button>
                    </div>
                </div>
            </form>
        </Dialog>

    )
}
